import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { UpdateMarginType } from "types/MarginTypes";
import { queryClient } from "App";

export const useUpdateMargin = (
  options?: UseMutationOptions<any, Error, UpdateMarginType>
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateMargin"],
    mutationFn: async ({ id, from, to, margin }) => {
      return axiosInstance
        .put(`/margins/${id}`, {
          from,
          to,
          margin,
        })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa aktualizacja marży...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "update-margin",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Pomyślnie zaktualizowano marżę.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "update-margin",
      });
      queryClient.invalidateQueries({ queryKey: ["margins"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      const errorMessage =
        error?.response?.data?.message || "Błąd podczas aktualizacji marży.";
      Toast({
        message: errorMessage,
        type: TOAST_TYPES_ENUM.ERROR,
        id: "update-margin",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdateMargin;
